/* 
  模块相关接口
*/

import req from '@/utils/request' //引入暴露出来的请求函数

export default {
  // 获取导航菜单
  findNav: params => req.get('/api/homePage/navigation', params),
}